import { isCareIndustryPageKey, type CareIndustryPageKey } from './careIndustryLabels.js';
import { careIndustryHeroCopy } from './careIndustryPages.js';
import { isRetailIndustryPageKey, type RetailIndustryPageKey } from './retailIndustryLabels.js';
import { retailIndustryHeroCopy } from './retailIndustryPages.js';
import type { LandingLocale } from './landingContentTypes.js';
import { isIndustryPageKey, type IndustryPageKey } from './industryPages.js';
import type { StaticPageContent } from './staticPageContent.js';

type ApplicantHeroCopy = Pick<StaticPageContent, 'title' | 'heroTitleHighlight'>;
const copy: Record<LandingLocale, Record<Exclude<IndustryPageKey,RetailIndustryPageKey | CareIndustryPageKey>, ApplicantHeroCopy>> = {
  "de": {
    "pflege": {
      "title": "Pflege braucht Menschen mit Zukunft.",
      "heroTitleHighlight": "Zukunft"
    },
    "einzelhandel": {
      "title": "Einzelhandel. Frische und Kundennähe.",
      "heroTitleHighlight": "Kundennähe"
    },
    "handwerk": {
      "title": "Handwerk. Menschen mit Zukunft.",
      "heroTitleHighlight": "Zukunft"
    },
    "gastro": {
      "title": "Gastronomie. Dein neuer Start.",
      "heroTitleHighlight": "Start"
    },
    "elektriker": {
      "title": "Elektrik & Elektronik mit Zukunft.",
      "heroTitleHighlight": "Zukunft"
    },
    "bauwesen": {
      "title": "Bauwesen. Baue deine Zukunft.",
      "heroTitleHighlight": "Zukunft"
    },
    "schweisser": {
      "title": "Schweißer. Dein Handwerk verbindet.",
      "heroTitleHighlight": "verbindet"
    },
    "cnc": {
      "title": "CNC. Präzision mit Zukunft.",
      "heroTitleHighlight": "Präzision"
    },
    "shk": {
      "title": "Sanitär, Heizung & Klima.",
      "heroTitleHighlight": "Klima"
    },
    "lkw-fahrer": {
      "title": "LKW-Fahrer. Zukunft am Steuer.",
      "heroTitleHighlight": "Zukunft"
    }
  },
  "en": {
    "pflege": {
      "title": "Care needs people with a future.",
      "heroTitleHighlight": "future"
    },
    "einzelhandel": {
      "title": "Retail. Fresh food. Real people.",
      "heroTitleHighlight": "people"
    },
    "handwerk": {
      "title": "Skilled trades. Your future.",
      "heroTitleHighlight": "future"
    },
    "gastro": {
      "title": "Hospitality. Your next step.",
      "heroTitleHighlight": "step"
    },
    "elektriker": {
      "title": "Electrical & electronics. Your future.",
      "heroTitleHighlight": "future"
    },
    "bauwesen": {
      "title": "Construction. Build your future.",
      "heroTitleHighlight": "future"
    },
    "schweisser": {
      "title": "Welding. Skills that connect.",
      "heroTitleHighlight": "connect"
    },
    "cnc": {
      "title": "CNC. Precision with a future.",
      "heroTitleHighlight": "Precision"
    },
    "shk": {
      "title": "Plumbing. Heating. Cooling.",
      "heroTitleHighlight": "Cooling"
    },
    "lkw-fahrer": {
      "title": "Truck driving. Your future.",
      "heroTitleHighlight": "future"
    }
  },
  "tr": {
    "pflege": {
      "title": "Bakımda geleceğin var.",
      "heroTitleHighlight": "geleceğin"
    },
    "einzelhandel": {
      "title": "Perakende. Senin geleceğin.",
      "heroTitleHighlight": "geleceğin"
    },
    "handwerk": {
      "title": "Zanaatla yeni bir geleceğe.",
      "heroTitleHighlight": "geleceğe"
    },
    "gastro": {
      "title": "Gastronomide geleceğin.",
      "heroTitleHighlight": "geleceğin"
    },
    "elektriker": {
      "title": "Elektrik ve elektronikte geleceğin.",
      "heroTitleHighlight": "geleceğin"
    },
    "bauwesen": {
      "title": "İnşaatla geleceğini kur.",
      "heroTitleHighlight": "İnşaatla"
    },
    "schweisser": {
      "title": "Kaynakçılık. Ustalığınla bağ kur.",
      "heroTitleHighlight": "Ustalığınla"
    },
    "cnc": {
      "title": "CNC. Hassasiyetle geleceğe.",
      "heroTitleHighlight": "Hassasiyetle"
    },
    "shk": {
      "title": "Tesisat, ısıtma ve klima.",
      "heroTitleHighlight": "klima"
    },
    "lkw-fahrer": {
      "title": "Kamyon şoförlüğünde geleceğin.",
      "heroTitleHighlight": "geleceğin"
    }
  }
};

// Applied only when creating editable defaults; saved editorial headlines remain untouched.
export const industryApplicantHeroDefaults = (page: StaticPageContent, locale: LandingLocale): StaticPageContent =>
  isCareIndustryPageKey(page.key) ? {...page,...careIndustryHeroCopy(page.key,locale,'applicant')} : isRetailIndustryPageKey(page.key) ? {...page,...retailIndustryHeroCopy(page.key,locale,'applicant')} : isIndustryPageKey(page.key) ? { ...page, ...copy[locale][page.key] } : page;
